"use strict";

var custKD = {
}

export default custKD;
